import { BaseDataService } from './../../base-services/base-data.service';
import { Component } from "@angular/core";
import { Router } from '@angular/router';

@Component({
    selector: 'account-confirm',
    templateUrl: './account-confirm.component.html'
})
export class AccountConfirm {
    accountConfirmed: boolean = false;
    accountAlreadyConfirmed: boolean = false;
    error: boolean = false;

    constructor(
        private baseDataService: BaseDataService,
        private router: Router  
    ) { }

    ngOnInit() {
        this.confirmUser();
    }

    confirmUser() {
        let code = this.getParam(window.location.href, 'code', 0);
        let userID = this.getParam(window.location.href, 'param', 1);
    
        let parameters = {
            Code: code,
            UserID: userID
        };
    
        console.log('Parameters:', parameters);
    
        this.baseDataService.GetData('account', 'confirmEmail', parameters)
            .subscribe((data: any) => {
                if (data) {
                    if (data.Succeeded) {
                        this.accountConfirmed = true;
                        setTimeout(() => {
                            this.router.navigate(['/login']);
                        }, 4000);
                    } else {
                        this.error = true;
                    }
                } else {
                    this.error = true;
                }
            }, (error) => {
                if (error.status === 409) { // 409 Conflict status
                    this.accountAlreadyConfirmed = true;
                } else {
                    this.error = true;
                }
            });
    }
    
    

    private getParam(location, param, paramIndex) {
        let index = location.indexOf(param);
        let value = '';
        if (index > -1) {
            value = location.split('&')[paramIndex];
            value = value.split('=')[1];
        }
        return value;
    }
}
